import React, { ReactNode } from 'react';
import styled, { ColorsTypes, FontsTypes } from 'styled-components';
import { space, typography, color, SpaceProps, TypographyProps, ColorProps } from 'styled-system';

type MyTypographyAllProps = React.HTMLAttributes<HTMLDivElement> & SpaceProps & TypographyProps & ColorProps;

interface MyTypographyProps extends MyTypographyAllProps {
  children?: ReactNode;
  type?: FontsTypes;
  upper?: boolean;
  colorHover?: ColorsTypes;
  underline?: boolean;
  as?: any;
  ref?: { current: any };
}

interface WrapperProps {
  type: FontsTypes;
  upper?: boolean;
  colorHover?: ColorsTypes;
  underline?: boolean;
}

const Wrapper = styled('div')<WrapperProps>`
  display: inline-block;
  line-height: 1.1;
  ${({ type, theme: { fontTypes } }) => (fontTypes && type && fontTypes[type] ? fontTypes[type] : '')}
  ${({ upper }) => (upper ? 'text-transform: uppercase;' : '')}
  ${space}
  ${typography}
  ${color}

  ${({ underline }) => (underline ? `text-decoration: underline;` : ``)}

  ${({ colorHover, theme }) => {
    if (colorHover) {
      return `&:hover {
        color: ${theme.colors[colorHover]};
      }`;
    }
  }}

  * {
    ${({ type, theme: { fontTypes } }) => (fontTypes && type && fontTypes[type] ? fontTypes[type] : '')}
  }
`;

const MyTypography = ({ children, type = 'type2', color = 'dark_350', ...props }: MyTypographyProps) => (
  <Wrapper type={type} color={color} {...props}>
    {children}
  </Wrapper>
);

export default MyTypography;
